import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import  useMonthlyFinanceData  from '../../hooks/useMonthlyFinanceData';
import { useState, useEffect } from 'react';
import CustomTooltip from '../MonthlyReportComponents/CustomTooltip'
import '../../Styles/LineChartComponent.css'

function LineChartComponent({selectedCompany, startDate}) {
    const { allData, allBudgetData, isFetching } = useMonthlyFinanceData(selectedCompany, new Date(startDate).getFullYear());
    const [showResultatCurrent, setShowResultatCurrent] = useState(true);
    const [showResultatLast, setShowResultatLast] = useState(true);
    const [showOmsætningCurrent, setShowOmsætningCurrent] = useState(true);
    const [showOmsætningLast, setShowOmsætningLast] = useState(true);
    const [showBudget, setShowBudgetLast] = useState(true);
    const [chartData, setChartData] = useState([]);
    function renderLegend(props) {
        const { payload, width } = props;
    
        const legendStyle = {
            fontSize: width > 768 ? '1em' : '0.75em'
            
        };
        return (
            <ul className="custom-legend" style={legendStyle}>
                {payload.map((entry, index) => (
                    <li key={`item-${index}`} onClick={() => handleLegendClick(entry)}>
                        <span style={{ marginRight: 4 }}>
                            {getCheckboxState(entry.dataKey)}
                        </span>
                        <span style={{ color: entry.color }}>
                            {entry.value}
                        </span>
                    </li>
                ))}
            </ul>
        );
    }
    
    function getCheckboxState(dataKey) {
        switch(dataKey) {
            case 'OmsætningNuværendeÅr':
                return showOmsætningCurrent ? '☑️' : '☐';
            case 'OmsætningLastYear':
                return showOmsætningLast ? '☑️' : '☐';
            case 'BudgetNuværendeÅr':
                return showBudget ? '☑️' : '☐';
            case 'ResultatNuværendeÅr':
                return showResultatCurrent ? '☑️' : '☐';
            case 'ResultatLastYear':
                return showResultatLast ? '☑️' : '☐';
            default:
                return '☐';
        }
    }

    function handleLegendClick(e) {
        switch(e.dataKey) {
            case 'OmsætningNuværendeÅr':
                setShowOmsætningCurrent(prev => !prev);
                break;
            case 'OmsætningLastYear':
                setShowOmsætningLast(prev => !prev);
                break;
            case 'BudgetNuværendeÅr':
                setShowBudgetLast(prev => !prev);
                break;
            case 'ResultatNuværendeÅr':
                setShowResultatCurrent(prev => !prev);
                break;
            case 'ResultatLastYear':
                setShowResultatLast(prev => !prev);
                break;
            default:
                break;
        }
    }

    function transformRawDataForChart(balanceData, budgetData, selectedYear) {
        const lastYear = selectedYear - 1;

        
        const currentResultData = new Array(12).fill({ month: null, amount: 0 });
        const lastYearResultData = new Array(12).fill({ month: null, amount: 0 });
        const currentYearData = new Array(12).fill({ month: null, amount: 0 });
        const lastYearData = new Array(12).fill({ month: null, amount: 0 });
        const currentYearBudget = new Array(12).fill({ month: null, amount: 0 });
        const lastYearBudget = new Array(12).fill({ month: null, amount: 0 });
        
        balanceData.forEach(dataObject => {
            if (!dataObject || !dataObject.data) return;
            
            const date = new Date(dataObject.month);
            const monthIndex = date.getMonth(); 
            const year = date.getFullYear();
    
            const omsætningData = dataObject.data.find(entry => entry.accountNumber === 1995);
            const resultatData = dataObject.data.find(entry => entry.accountNumber === 5998);
    
            if (year === lastYear) {
                if (omsætningData) {
                    lastYearData[monthIndex] = { month: monthIndex, amount: omsætningData.amount };
                }
                if (resultatData) {
                    lastYearResultData[monthIndex] = { month: monthIndex, amount: resultatData.amount };
                }
            } else if (year === selectedYear) {
                if (omsætningData) {
                    currentYearData[monthIndex] = { month: monthIndex, amount: omsætningData.amount };
                }
                if (resultatData) {
                    currentResultData[monthIndex] = { month: monthIndex, amount: resultatData.amount };
                }
            }
        });
    
        budgetData.forEach(dataObject => {
            if (!dataObject || !dataObject.data) return;
    
            const omsætningBudgetData = dataObject.data.find(entry => entry.accountNumber === 1995);
            if (!omsætningBudgetData || !omsætningBudgetData.periods || omsætningBudgetData.periods.length === 0) return;
            
            const amountFromBudget = omsætningBudgetData.periods[0].amount; 
            if (amountFromBudget === null) return; 
    
            const date = new Date(dataObject.month);
            const monthIndex = date.getMonth(); 
            const year = date.getFullYear();
            
            if(year === lastYear) {
                lastYearBudget[monthIndex] = { month: monthIndex, amount: amountFromBudget };
            } else if(year === selectedYear) {
                currentYearBudget[monthIndex] = { month: monthIndex, amount: amountFromBudget };
            }
        });
    
        const mergedData = [];
        for (let i = 0; i < 12; i++) {
            const current = currentYearData[i] || { amount: 0 };
            const last = lastYearData[i] || { amount: 0 };
            const currentBudget = currentYearBudget[i] || { amount: 0 };
            const currentResult = currentResultData[i] || {amount: 0};
            const lastYearResult = lastYearResultData[i] || {amount: 0};
            
    
            mergedData.push({
                month: new Date(selectedYear, i).toLocaleString('default', { month: 'short' }),
                OmsætningNuværendeÅr: Math.abs(currentYearData[i].amount || 0),
                OmsætningLastYear: Math.abs(lastYearData[i].amount || 0),
                BudgetNuværendeÅr: Math.abs(currentYearBudget[i].amount || 0),
                ResultatNuværendeÅr: Math.abs(currentResultData[i].amount || 0),
                ResultatLastYear: Math.abs(lastYearResultData[i].amount || 0)
            });
        }
        return mergedData;
    }


    const yAxisFormatter = (value) => {
        if (value >= 1000000) {
          return `${(value / 1000000).toFixed(1)}M`;
        }
        if (value >= 1000) {
          return `${(value / 1000).toFixed(1)}K`;
        }
        return value;
      };


      
      useEffect(() => {
        if (!isFetching) {
            const selectedYear = new Date(startDate).getFullYear();
            const lastYear = selectedYear - 1;
            const filteredData = allData.filter(item => {
                const year = new Date(item.month).getFullYear();
                return year === selectedYear || year === lastYear;
            });
            const filteredBudgetData = allBudgetData.filter(item => {
                const year = new Date(item.month).getFullYear();
                return year === selectedYear || year === lastYear;
            });
            const transformedData = transformRawDataForChart(filteredData, filteredBudgetData, selectedYear);
            setChartData(transformedData);
        }
    }, [isFetching, selectedCompany, allData, allBudgetData, startDate]);
    
    
    

    return (
        <div className="line-chart-component">
             <div >
                <h2 className="sub-header">Omsætning og Resultat</h2>
            </div>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData} margin={{  right: 20, bottom: 25, left: 0 }}>
              <CartesianGrid stroke="#f5f5f5" strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={yAxisFormatter}/>
              <Tooltip content={<CustomTooltip />} />
              <Legend content={renderLegend} wrapperStyle={{ position: 'relative' }} />
            <Line type="monotone" dataKey="OmsætningNuværendeÅr" stroke="#ff7300" strokeWidth={2} name="Omsætning Nuværende År" visibility={showOmsætningCurrent ? 'visible' : 'hidden'}/>
            <Line type="monotone" dataKey="OmsætningLastYear" stroke="#387908" strokeWidth={2} name="Omsætning Sidste År" visibility={showOmsætningLast ? 'visible' : 'hidden'}/>
            <Line type="monotone" dataKey="BudgetNuværendeÅr" stroke="#00008b" strokeWidth={2} name="Budget Nuværende År" visibility={showBudget ? 'visible' : 'hidden'}/>
            <Line type="monotone" dataKey="ResultatNuværendeÅr" stroke="#cc0000" strokeWidth={2} name="Årets Resultat Nuværende År" visibility={showResultatCurrent ? 'visible' : 'hidden'}/>
            <Line type="monotone" dataKey="ResultatLastYear" stroke="#660000" strokeWidth={2} name="Årets Resultat Sidste År" visibility={showResultatLast ? 'visible' : 'hidden'}/>
            </LineChart>
          </ResponsiveContainer>
        </div>
    );
}

export default LineChartComponent;
